import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import CategoryBrowse from './components/CategoryBrowse';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/data';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩影深解 - 韩国电影推荐与深度解析 | 探索韩国电影的魅力世界"
        description="韩国电影推荐与深度解析，探索韩国电影的魅力世界——从经典佳作到最新力作，深度解析韩国电影的叙事风格、社会议题与文化内涵，为影迷提供最全面的韩国电影观影指南与推荐榜单。"
        keywords="韩国电影,韩国电影推荐,韩国电影排行榜,韩国电影类型,韩国电影导演,韩国犯罪电影,韩国爱情电影,韩国电影奥斯卡"
        canonicalUrl="https://hanyingshenjie.com"
        ogType="website"
        faqSchema={faqs.map((f) => ({ question: f.question, answer: f.answer }))}
      />
      <main>
        <HeroSection />
        <FeaturedMovies />
        <CategoryBrowse />
        <LatestArticles />
        <FAQSection />
      </main>
    </>
  );
}